import type { FC } from "react"
import { useRef } from "react"

import { useRecoilState } from "recoil"

import { panState } from "../../state/view"
import { Pan } from "../Interactions/Pan"

export const PanRectangle: FC = () => {
  const [pan, setPan] = useRecoilState(panState)

  const draggableRef = useRef(null)

  return (
    <Pan nodeRef={draggableRef} onDrag={setPan} position={pan}>
      <rect
        style={{
          touchAction: `none`,
        }}
        width="100%"
        height="100%"
        fill="transparent"
        ref={draggableRef}
      />
    </Pan>
  )
}
